// InternalPageLayout.js
import { useState } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BASE_URL } from "../constant/apiUrl";
import Loading from "../utils/Loader";
import TabContentView from "../components/LibraryPage/TabContentView";
import LibraryFilter from "../components/LibraryPage/LibraryFilter";
import { Link, useParams } from "react-router-dom";
import ViewSummary from "../components/ViewSummary/ViewSummary";
import { setLibraryPageDetails } from "../slices/LibraryPageSlice";
import useFetchGlobal from "../hooks/useFetchGlobal";

export default function LibraryDetails() {
  const selectedView = useSelector((state) => state.view);
  const [searchText, setSearchText] = useState(null);
  const [grid, setGrid] = useState(selectedView);
  const [cropType, setCropType] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [languageFilter, setLanguageFilter] = useState("");
  const [localSector, setLocalSector] = useState(null);
  const queryParams = useParams();
  const { viewSummaryDrawer } = useSelector((store) => store.viewSummary);
  const { librayDetails } = useSelector((store) => store.libraryDetailPage);

  const { loading } = useFetchGlobal(
    `${BASE_URL}/library-page/find-by-subject-id?subjectId=${queryParams?.id}`,
    setLibraryPageDetails,
    "Library"
  );
  if (loading) {
    return <Loading data-testid="loading" />;
  }
  return (
    <Box
      sx={{
        mt: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        paddingX: { xs: "16px", md: "53px" },
      }}
    >
      <div
        style={{
          display: "flex",
          height: "40px",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Link
          to={"/library"}
          style={{
            fontWeight: 700,
            textAlign: "left",
            textUnderlinePosition: "from-font",
            textDecorationSkipInk: "none",
            color: "#005CBC",
          }}
        >
          <ArrowBackIcon
            sx={{
              width: "24px",
              height: "24px",
              top: "2px",
              left: "4px",
              paddingRight: "8px",
            }}
          />
          Back to library
        </Link>
      </div>

      <Box sx={{ zIndex: 1000 }}>
        {/* Pass setSelection to InternalFilter */}
        <LibraryFilter
          setGrid={setGrid}
          header={"LibraryDetails"}
          grid={grid}
          setSelection={null}
          setSearchTextData={setSearchText}
          setCropType={setCropType}
          setCountryFilter={setCountryFilter}
          setLanguageFilter={setLanguageFilter}
          setLocalSector={setLocalSector}
          localSector={localSector}
        />
      </Box>
      <TabContentView
        tabData={librayDetails}
        pageName="LibraryDetails"
        selectedView={grid}
        data-testid="tab-content"
        searchText={searchText}
        cropType={cropType}
        countryFilter={countryFilter}
        languageFilter={languageFilter}
        localSector={localSector}
      />
      {viewSummaryDrawer && <ViewSummary data-testid="view-summary" />}
    </Box>
  );
}
